function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "filter_svg__a",
  d: "M0 0h15v5H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "filter_svg__c",
  d: "M0 0h15v5H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "filter_svg__e",
  d: "M0 0h15v5H0z"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(.5 .5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "filter_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#filter_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.357 1.857H9.906A2.497 2.497 0 007.5 0C6.345 0 5.38.791 5.094 1.857H.643a.643.643 0 000 1.286h4.451A2.497 2.497 0 007.5 5c1.155 0 2.12-.791 2.406-1.857h4.451a.643.643 0 000-1.286",
  fill: "#FFF",
  fillRule: "nonzero",
  mask: "url(#filter_svg__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 10)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "filter_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#filter_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0c-1.155 0-2.12.791-2.406 1.857H.643a.643.643 0 000 1.286h9.451A2.497 2.497 0 0012.5 5C13.879 5 15 3.878 15 2.5 15 1.121 13.879 0 12.5 0",
  fill: "#FFF",
  fillRule: "nonzero",
  mask: "url(#filter_svg__d)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "filter_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#filter_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.5 5c1.155 0 2.12-.791 2.406-1.857h9.451a.643.643 0 000-1.286H4.906A2.497 2.497 0 002.5 0 2.503 2.503 0 000 2.5C0 3.878 1.12 5 2.5 5",
  fill: "#FFF",
  fillRule: "nonzero",
  mask: "url(#filter_svg__f)"
}));
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}
export default SvgFilter;